import ApiClient from './ApiClient';

// Wire shape is pinned camelCase on the backend (Plan 06 Task 3 prerequisite —
// FeaturesResponseDto): { mining: boolean, colo: boolean }.
const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.error || error?.message || fallback;

class FeaturesClient extends ApiClient {
  constructor(url) {
    // No shared prefix between `features` and `colo/org-features` — every method below
    // specifies its own full path off the base service url (mirrors GatewayClient/PoolClient's
    // "serviceUrl + per-method path" convention, just with an empty serviceUrl).
    super(url || '');
  }

  // GET features — any authenticated user, called once at login by the features Redux slice.
  async getFeatures() {
    try {
      return await this.get('/features');
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Failed to fetch features.'));
    }
  }

  // GET colo/org-features — admin-only read of the caller's own org's flags (Flags screen).
  async getOrgFeatures() {
    try {
      return await this.get('/colo/org-features');
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to fetch org features.')
      );
    }
  }

  // PUT colo/org-features — admin-only update; body is { mining, colo }.
  async updateOrgFeatures(body) {
    try {
      return await this.put('/colo/org-features', body);
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to update org features.')
      );
    }
  }
}

export default FeaturesClient;
